export const GET_CASE_ID_FORM=`GET_CASE_ID_FORM`;
export const SET_CASE_ID_FORM=`SET_CASE_ID_FORM`;
export const SET_CLOSE_CONTACT=`SET_CLOSE_CONTACT`;
export const GET_CLOSE_CONTACT=`GET_CLOSE_CONTACT`;
export const SET_SAVE_NOT_CLOSED=`SET_SAVE_NOT_CLOSED`;
export const GET_SAVE_NOT_CLOSED=`GET_SAVE_NOT_CLOSED`;
export const GET_POSITION=`GET_POSITION`;
export const GET_CONTACT=`GET_CONTACT`;
export const SET_POSITION=`SET_POSITION`;
export const SET_CONTACT=`SET_CONTACT`;

export const getCaseIdForm =(caseId, edm) =>({
    type: GET_CASE_ID_FORM,
    payload:caseId,
    edm:edm
})

export const setCaseIdForm =(data) =>({
    type: SET_CASE_ID_FORM, 
    value: data
});

export const setCloseContact =(data) =>({
    type: SET_CLOSE_CONTACT, 
    value: data
});

export const getCloseContact =(data, caseId) =>({
    type: GET_CLOSE_CONTACT, 
    value: data,
    caseId:caseId
});

export const setSaveNotClosed =(data) =>({
    type: SET_SAVE_NOT_CLOSED, 
    value: data
});

export const getSaveNotClosed =(data, caseId) =>({
    type: GET_SAVE_NOT_CLOSED, 
    value: data,
    caseId:caseId
});

export const getPosition =() =>({
    type: GET_POSITION, 
});

export const getContact =() =>({
    type: GET_CONTACT, 
});

export const setPosition =(data) =>({
    type: SET_POSITION, 
    value: data
});

export const setContact =(data) =>({
    type: SET_CONTACT, 
    value: data
});

